import React, { useState, useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";

export type AddError = (error: string) => void;

export function ErrorNotifier({
  children,
}: {
  children: React.FunctionComponent<{ addError: AddError }>;
}) {
  const [error, setError] = useState<string | null>(null);
  const timeout = useRef<any>();
  const { t } = useTranslation();

  const addError: AddError = useCallback(
    (error: string) => {
      setError(error);
      if (timeout.current) {
        window.clearTimeout(timeout.current);
      }
      timeout.current = window.setTimeout(() => setError(null), 3000);
    },
    [setError],
  );

  return (
    <>
      {error ? (
        <div
          style={{
            width: "100%",
            height: "20px",
            background: "rgba(255,166,166,0.51)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "12px",
          }}
        >
          {t(error, "Something went wrong")}
        </div>
      ) : null}
      {children({ addError })}
    </>
  );
}
